import React from 'react';
import { Container } from 'react-bootstrap';
import AzureIndicators from './components/AzureIndicators';
import HeroSection from './components/HeroSection';
import Experience from './components/Experience';
import YouTubeFeed from './components/YouTubeFeed';
import Footer from './components/Footer';
import apiConfig from './config/apiConfig';

function App() {
  // Log environment info to help with debugging
  console.log(`Running in ${apiConfig.environment} environment`);
  console.log(`API URL: ${apiConfig.azureFunctionsBaseUrl}`);
  
  return (
    <div className="App">
      <AzureIndicators />
      <HeroSection />
      <Container>
        <Experience />
        <YouTubeFeed />
      </Container>
      <Footer />
    </div>
  );
}

export default App;